
































import { Component } from "vue-property-decorator";
import { mixins } from "vue-class-component";
import UserValidator from "@/resources/mixins/userValidator";
import SidebarHelpComponent from "@/app/views/nubii/components/sidebar/components/sidebarHelp.component.vue";
import CollapseButtonComponent from "@/app/views/nubii/components/sidebar/components/collapseButton.component.vue";
import Plans from "@/resources/mixins/plans/plans";
import { PLAN } from "@/resources/constants/plan";
@Component({
  name: "config-utilities-component",
  components: { CollapseButtonComponent, SidebarHelpComponent },
})
export default class ConfigUtilitiesComponent extends mixins(UserValidator, Plans) {
  physicalRooms = [];
  PLAN = PLAN;
  openSpotifyModal() {
    if (!this.activeOptionPlan(PLAN.SPOTIFY_LIST))
      return;
    let open = this.$store.getters["SystemStore/getOpenSpotifyModal"];
    this.$store.dispatch("SystemStore/setOpenSpotifyModalAction", !open);
  }
  openCalendar() {
    this.$store.dispatch("SystemStore/setReserveRoomModalAction", true);
  }
  openReservePhysicalRooms() {
    this.$store.dispatch("SystemStore/setReservePhysicalRoomModalAction", true);
  }
  getPlant() {
    if (!this.activeOptionPlan(PLAN.PHYSICAL_ROOM_RESERVATIONS)) return;
    const space = this.$store.getters["SpaceStore/getSpace"];
    this.$store.dispatch("SuperSpaceStore/getPhysicalPlantAndRoomsAction", {
      superSpaceId: space.superSpace.id,
      callback: (response) => {
        this.physicalRooms = response;
      },
      callbackError: (error) => {
        this.physicalRooms = [];
        console.log("TTT ConfigUtilitiesComponent getPlant KO ", error);
      },
    });
  }
}
